const formatNumber = (number: number) => {
    return new Intl.NumberFormat( 'es-ES', { style: 'currency', currency: 'EUR' }).format(number)
}

export default {
    formatNumber
}